module.exports = __webpack_public_path__ + "console/img/mastek_small@2x.9a92ff86.png";